export const isCorrectPhone = (value) => {
  const phone = value.replace(/\D/g, ``);
  return phone.length === 11;
};
